import { DEFAULT_SCHEME_PREFIX_MAP } from '../constants/color-schemes';

const buildPaletteTemplateVariables = ({ root: rootVars, schemes: schemeVars }) => {
  const prefixedSchemeVars = {};

  Object.entries(DEFAULT_SCHEME_PREFIX_MAP).forEach(([schemeId, prefix]) => {
    Object.entries(schemeVars[schemeId] || {}).forEach(([key, value]) => {
      prefixedSchemeVars[`${prefix}_${key}`] = value;
    });
  });

  return { ...rootVars, ...prefixedSchemeVars };
};

export default buildPaletteTemplateVariables;
